import { useEffect } from "react";

export const shortCutAddr = (account: string, sliceNum = 4) => {
  return account == null
    ? "not connected"
    : account.slice(0, sliceNum) + "..." + account.slice(-sliceNum);
};

export function useMyInterval(callback: any, ms: number) {
  useEffect(() => {
    callback();
    const interval = setInterval(callback, ms);
    return () => clearInterval(interval);
  });
}

export function zeroNum(n: number): string {
  if (n < 10) return `0${n}`;
  return `${n}`;
}

export function formatError(e: any): Error {
  if (typeof e === "string") return Error(e);
  if (isMetamaskError2(e)) {
    try {
      const reason = e.reason || "";
      const str = matchRevert0(reason) || matchRevert1(reason);
      if (str) {
        return Error(`${str}`);
      }
    } catch (e1) {
      return Error(`${e.reason}`);
    }
  }
  if (isMetamaskError(e)) {
    const message = e.message;
    return Error(`code = ${e.data.code}, message = ${e.data.message}`);
  }

  if (isMetamaskError3(e)) {
    const reason = e.reason || "";
    const str = matchRevert0(reason) || matchRevert1(reason);
    if (str) {
      return Error(`${str}`);
    }
    return Error(e.reason);
  }

  debugger;
  if (e instanceof Error) return e;
  if ("message" in e) {
    return Error(e.message);
  }
  return e;
}

function matchRevert0(reason: string) {
  const arr = reason.match(/reverted with reason string \'(.+)'$/);
  if (arr?.length === 2) {
    return arr[1];
  }
  return null;
}

function matchRevert1(reason: string) {
  const arr = reason.match(/execution reverted: (.+)$/);
  if (arr?.length === 2) {
    return arr[1];
  }
  return null;
}

export function errorMsg(e: any) {
  const err = formatError(e);
  if ("message" in err) return err.message;
  return e.toString();
}

interface iMetamaskError {
  code: number;
  message: string;
  data: {
    code: number;
    message: string;
  };
}

interface iMetamaskError2 {
  code: number;
  error: iMetamaskError;
  method: string;
  reason: string;
  message: string;
}

interface iMetamaskError3 {
  code: string;
  error: iMetamaskError;
  method: string;
  reason: string;
  message: string;
}

interface iMetamaskError4 {
  code: number;
  data: any;
  message: string;
}

function isMetamaskError(e: iMetamaskError | any): e is iMetamaskError {
  return (
    e.code != null &&
    e.message != null &&
    e.data != null &&
    e.data.code != null &&
    e.data.message != null
  );
}

function isMetamaskError2(e: iMetamaskError2 | any): e is iMetamaskError2 {
  return e.code != null && isMetamaskError(e.error);
}

function isMetamaskError3(e: iMetamaskError3 | any): e is iMetamaskError3 {
  return (
    typeof e.code === "string" &&
    e.reason &&
    isMetamaskError4(e.error) &&
    e.method
  );
}

function isMetamaskError4(e: iMetamaskError3 | any): e is iMetamaskError3 {
  if (!e) return false;
  const keys = Object.keys(e);
  return (
    keys.includes("code") && keys.includes("data") && keys.includes("message")
  );
}
